import DocumentNumberField from './DocumentNumberField';

export const STEP_COMPONENTS_TYPES = {
  DOCUMENT_NUMBER_FIELD: 'document-number-field'
};

export const stepComponentsMap = {
  [STEP_COMPONENTS_TYPES.DOCUMENT_NUMBER_FIELD]: DocumentNumberField
};
